import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4567503b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-checkbox" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { for: "checkbox" }

interface CheckboxProps {
  checked: boolean
  label?: string
}

const __default__ = {
  name: 'Checkbox'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    checked: { type: Boolean, default: false },
    label: null
  },
  emits: ["update:checked"],
  setup(__props: any, { emit }) {

const props = __props as { checked: boolean, label?: string };

// 属性


// 方法


const update = (e: Event) => {
  const targetChecked = (e.target as HTMLInputElement).checked
  emit("update:checked", targetChecked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      id: "checkbox",
      checked: __props.checked,
      onInput: update
    }, null, 40, _hoisted_2),
    _createElementVNode("label", _hoisted_3, _toDisplayString(__props.label), 1)
  ]))
}
}

})